import { MapsetS100m01Component } from './mapset-s100m01.component';

export { MapsetModule } from './mapset.module';

export const MapsetSubComponentsMap = {
	
};

export const MapsetComponentsMap = {
	"mapset-s100m01": MapsetS100m01Component
};

export const MapsetComponents = [
	MapsetS100m01Component
];

